export default "__VITE_ASSET__DkrFjQ1a__"